<template>
    <div class="text-20 text-center">{{ $t("views.request.modal.approve.confirm") }}</div>
</template>

<script>
import { defineComponent, reactive } from "vue";
import { initForm, isLoading, onClickModalOk } from "./confirm-wait-doc-customs.logic";

export default defineComponent({
    components: {},
    props: {
        viewOnly: { default: false },
        form: {}
    },
    setup(props) {
        const data = reactive({ rowProp: { gutter: 24 } });
        const refs = reactive({ form: null });
        initForm({ props, data, refs });
        const callOnClickModalOk = () => onClickModalOk({ data, refs });
        return {
            props,
            data,
            refs,
            isLoading,
            callOnClickModalOk
        };
    }
});
</script>
